import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalLoginComponent } from './modal-login.component';

@Injectable({
  providedIn: 'root'
})
export class ModalLoginService {
  bsModalRef: BsModalRef;

  constructor(
    private bsModalService: BsModalService,
  ) { }

  confirm(title: string): Observable<string> {
    const initialState = {
      title: title  
    };
    this.bsModalRef = this.bsModalService.show(ModalLoginComponent, { initialState, class: 'modal-dialog-centered', backdrop: 'static' });

    return new Observable<string>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer) => {
      const subscription = this.bsModalService.onHidden.subscribe((reason: string) => {
        observer.next(this.bsModalRef.content.answer);
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        }
      };
    };
  }
}
